import { render } from "./BlockIconPicker.vue?vue&type=template&id=7663891c"
import script from "./BlockIconPicker.vue?vue&type=script&lang=js"
export * from "./BlockIconPicker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__